<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<router-outlet cfBlockCopyPaste *ngIf="(online$ | async)"></router-outlet>
<div *ngIf="!(online$ | async)" class="a">
    <b>Please check your internet connection, then try again</b>
</div>